import { render, staticRenderFns } from "./TypeRegister.vue?vue&type=template&id=033ee15a"
import script from "./TypeRegister.vue?vue&type=script&lang=js"
export * from "./TypeRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports